"use strict";
/* eslint-disable object-curly-newline */

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://www.justice.gov/ust/eo/bapcpa/20230401/bci_data/median_income_table.htm

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error("Missing State");
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error("Missing Persons Count");
  var medianMap = {
    AK: {
      "1": 79250,
      "2": 94750,
      "3": 109774,
      "4": 125973
    },
    AL: {
      "1": 57248,
      "2": 69556,
      "3": 83258,
      "4": 90642
    },
    AR: {
      "1": 52497,
      "2": 64523,
      "3": 74116,
      "4": 86582
    },
    AZ: {
      "1": 63717,
      "2": 80352,
      "3": 90789,
      "4": 103676
    },
    CA: {
      "1": 71861,
      "2": 92781,
      "3": 105130,
      "4": 123451
    },
    CO: {
      "1": 74274,
      "2": 97698,
      "3": 115443,
      "4": 130450
    },
    CT: {
      "1": 78071,
      "2": 97337,
      "3": 119521,
      "4": 143283
    },
    DC: {
      "1": 82535,
      "2": 136088,
      "3": 166120,
      "4": 173924
    },
    DE: {
      "1": 72682,
      "2": 88592,
      "3": 100314,
      "4": 122990
    },
    FL: {
      "1": 60483,
      "2": 74569,
      "3": 86353,
      "4": 99954
    },
    GA: {
      "1": 59998,
      "2": 76648,
      "3": 87363,
      "4": 108220
    },
    GU: {
      "1": 48960,
      "2": 58540,
      "3": 66709,
      "4": 80726
    },
    HI: {
      "1": 75632,
      "2": 90934,
      "3": 109103,
      "4": 128372
    },
    IA: {
      "1": 58860,
      "2": 80287,
      "3": 95073,
      "4": 115551
    },
    ID: {
      "1": 66062,
      "2": 75857,
      "3": 87216,
      "4": 102200
    },
    IL: {
      "1": 64303,
      "2": 83024,
      "3": 101710,
      "4": 120079
    },
    IN: {
      "1": 57965,
      "2": 74513,
      "3": 87816,
      "4": 101407
    },
    KS: {
      "1": 61967,
      "2": 79416,
      "3": 96366,
      "4": 106796
    },
    KY: {
      "1": 55235,
      "2": 67141,
      "3": 80316,
      "4": 98032
    },
    LA: {
      "1": 51693,
      "2": 63440,
      "3": 74830,
      "4": 93308
    },
    MA: {
      "1": 77961,
      "2": 99316,
      "3": 122289,
      "4": 154778
    },
    MD: {
      "1": 78079,
      "2": 100435,
      "3": 122350,
      "4": 145162
    },
    ME: {
      "1": 63745,
      "2": 76495,
      "3": 99855,
      "4": 110060
    },
    MI: {
      "1": 62026,
      "2": 74532,
      "3": 91988,
      "4": 109931
    },
    MN: {
      "1": 69460,
      "2": 90144,
      "3": 112783,
      "4": 136293
    },
    MO: {
      "1": 57248,
      "2": 73751,
      "3": 87722,
      "4": 101726
    },
    MP: {
      "1": 32878,
      "2": 32878,
      "3": 38251,
      "4": 56260
    },
    MS: {
      "1": 49516,
      "2": 60025,
      "3": 71947,
      "4": 81416
    },
    MT: {
      "1": 62663,
      "2": 77585,
      "3": 81241,
      "4": 107107
    },
    NC: {
      "1": 59367,
      "2": 75315,
      "3": 86408,
      "4": 105257
    },
    ND: {
      "1": 64171,
      "2": 85966,
      "3": 100101,
      "4": 117698
    },
    NE: {
      "1": 61290,
      "2": 80114,
      "3": 94702,
      "4": 116653
    },
    NH: {
      "1": 80695,
      "2": 95861,
      "3": 125236,
      "4": 147670
    },
    NJ: {
      "1": 79816,
      "2": 96779,
      "3": 125090,
      "4": 151181
    },
    NM: {
      "1": 54522,
      "2": 68459,
      "3": 74842,
      "4": 80287
    },
    NV: {
      "1": 61865,
      "2": 77817,
      "3": 85474,
      "4": 95872
    },
    NY: {
      "1": 66402,
      "2": 84089,
      "3": 101266,
      "4": 126194
    },
    OH: {
      "1": 59181,
      "2": 74739,
      "3": 91160,
      "4": 108950
    },
    OK: {
      "1": 53173,
      "2": 68234,
      "3": 78963,
      "4": 87909
    },
    OR: {
      "1": 67488,
      "2": 82858,
      "3": 99199,
      "4": 114710
    },
    PA: {
      "1": 64277,
      "2": 78349,
      "3": 99093,
      "4": 120885
    },
    PR: {
      "1": 26136,
      "2": 26136,
      "3": 31073,
      "4": 41817
    },
    RI: {
      "1": 69648,
      "2": 89735,
      "3": 115152,
      "4": 133440
    },
    SC: {
      "1": 57302,
      "2": 71914,
      "3": 84463,
      "4": 98202
    },
    SD: {
      "1": 61337,
      "2": 80420,
      "3": 93764,
      "4": 108540
    },
    TN: {
      "1": 56717,
      "2": 72442,
      "3": 85423,
      "4": 95748
    },
    TX: {
      "1": 59030,
      "2": 76712,
      "3": 86290,
      "4": 104562
    },
    UT: {
      "1": 75797,
      "2": 83851,
      "3": 102082,
      "4": 115435
    },
    VA: {
      "1": 72761,
      "2": 91707,
      "3": 112281,
      "4": 134145
    },
    VI: {
      "1": 38846,
      "2": 46687,
      "3": 49778,
      "4": 54537
    },
    VT: {
      "1": 63114,
      "2": 84727,
      "3": 107553,
      "4": 127123
    },
    WA: {
      "1": 83136,
      "2": 96815,
      "3": 113759,
      "4": 134300
    },
    WI: {
      "1": 63492,
      "2": 79090,
      "3": 97477,
      "4": 117725
    },
    WV: {
      "1": 55687,
      "2": 61929,
      "3": 79841,
      "4": 86599
    },
    WY: {
      "1": 59420,
      "2": 74189,
      "3": 89591,
      "4": 108590
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9900 : 0);
}

exports.default = getStateMedianFamilyIncome; // Scraping helper script
// const states = {
//   AL: 'Alabama',
//   AK: 'Alaska',
//   AS: 'American Samoa',
//   AZ: 'Arizona',
//   AR: 'Arkansas',
//   CA: 'California',
//   CO: 'Colorado',
//   CT: 'Connecticut',
//   DE: 'Delaware',
//   DC: 'District Of Columbia',
//   FM: 'Federated States Of Micronesia',
//   FL: 'Florida',
//   GA: 'Georgia',
//   GU: 'Guam',
//   HI: 'Hawaii',
//   ID: 'Idaho',
//   IL: 'Illinois',
//   IN: 'Indiana',
//   IA: 'Iowa',
//   KS: 'Kansas',
//   KY: 'Kentucky',
//   LA: 'Louisiana',
//   ME: 'Maine',
//   MH: 'Marshall Islands',
//   MD: 'Maryland',
//   MA: 'Massachusetts',
//   MI: 'Michigan',
//   MN: 'Minnesota',
//   MS: 'Mississippi',
//   MO: 'Missouri',
//   MT: 'Montana',
//   NE: 'Nebraska',
//   NV: 'Nevada',
//   NH: 'New Hampshire',
//   NJ: 'New Jersey',
//   NM: 'New Mexico',
//   NY: 'New York',
//   NC: 'North Carolina',
//   ND: 'North Dakota',
//   MP: 'Northern Mariana Islands',
//   OH: 'Ohio',
//   OK: 'Oklahoma',
//   OR: 'Oregon',
//   PW: 'Palau',
//   PA: 'Pennsylvania',
//   PR: 'Puerto Rico',
//   RI: 'Rhode Island',
//   SC: 'South Carolina',
//   SD: 'South Dakota',
//   TN: 'Tennessee',
//   TX: 'Texas',
//   UT: 'Utah',
//   VT: 'Vermont',
//   VI: 'Virgin Islands',
//   VA: 'Virginia',
//   WA: 'Washington',
//   WV: 'West Virginia',
//   WI: 'Wisconsin',
//   WY: 'Wyoming',
// };
// function innerTextToNumber(str) {
//   return Number((str || '').replace(/[\D|,]/, '').replace(',', ''));
// }
// const unsorted = Array.from(document.querySelectorAll('table thead tr'))
//     .slice(3)
//     .map(r => ({
//       state: Object.keys(states).find(stKey => states[stKey] === Object.values(states).find(st => st.toUpperCase() === (r.querySelector('td:nth-of-type(1)') || {}).innerText)),
//       1: innerTextToNumber((r.querySelector('td:nth-of-type(2)') || {}).innerText),
//       2: innerTextToNumber((r.querySelector('td:nth-of-type(3)') || {}).innerText),
//       3: innerTextToNumber((r.querySelector('td:nth-of-type(4)') || {}).innerText),
//       4: innerTextToNumber((r.querySelector('td:nth-of-type(5)') || {}).innerText),
//     }))
//     .filter(obj => (obj.state || '').length)
//     .reduce((accum, obj) => ({
//       [obj.state]: {
//         1: obj[1],
//         2: obj[2],
//         3: obj[3],
//         4: obj[4],
//       },
//       ...accum,
//     }), {});
// Object.keys(unsorted)
//   .sort()
//   .reduce((acc, key) => {
//     acc[key] = unsorted[key];
//     return acc;
//   }, {});